export const saveNSAData={
    NEW_SERVICE_AGREEMENT_DATA_SAVE_SUCCESS:"NEW_SERVICE_AGREEMENT_DATA_SAVE_SUCCESS",
  }